import {
  GET_POSITION,
  CREATE_POSITION,
  POSITION_LOADING,
  DELETE_POSITION,
  POSITION_ERROR,
} from '../actions/types';

const initialState = {
  positionlist: [],
  positionLoading: false,
  error: {},
};

//eslint-disable-next-line
export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case POSITION_LOADING:
      return {
        ...state,
        positionLoading: true,
      };
    case GET_POSITION:
      return {
        ...state,
        positionlist: payload,
        positionLoading: false,
      };
    case CREATE_POSITION:
      return {
        ...state,
        positionlist: [payload, ...state.positionlist],
        positionLoading: false,
      };
    case POSITION_ERROR:
      return {
        ...state,
        error: payload,
        positionLoading: false,
      };
    case DELETE_POSITION:
      return {
        ...state,
        positionlist: state.positionlist.filter(
          (position) => position._id !== payload
        ),
        positionLoading: false,
      };
    default:
      return state;
  }
}
